import React from 'react';
import { IonIcon } from '@ionic/react';
import { arrowBack, arrowBackCircle, bookmark } from 'ionicons/icons';
import { Backbutton, Bookmarkbutton, TopNavContainer } from './InnerPageStyles';
import { useHistory } from 'react-router';
import BookmarkPlaceButton from '../BookmarkButton/BookmarkPlaceButton';

type TopNavProps = {
	placeId: number;
};
const PlaceTopNav: React.FC<TopNavProps> = ({ placeId }) => {
	const history = useHistory();
	return (
		<TopNavContainer>
			<Backbutton>
				<IonIcon
					icon={arrowBack}
					onClick={() => {
						if (window.history.length > 1) {
							history.goBack();
						} else {
							history.replace('/home');
						}
					}}
				/>
			</Backbutton>
			<BookmarkPlaceButton placeId={placeId} />
		</TopNavContainer>
	);
};

export default PlaceTopNav;
